function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l6-6a1 1 0 00-1.414-1.414L6 9.586 4.707 8.293z",
  fill: "#fff"
});

function SvgCheckSquare16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNzA3MTEgOC4yOTI4OUM0LjMxNjU4IDcuOTAyMzcgMy42ODM0MiA3LjkwMjM3IDMuMjkyODkgOC4yOTI4OUMyLjkwMjM3IDguNjgzNDIgMi45MDIzNyA5LjMxNjU4IDMuMjkyODkgOS43MDcxMUw1LjI5Mjg5IDExLjcwNzFDNS42ODM0MiAxMi4wOTc2IDYuMzE2NTggMTIuMDk3NiA2LjcwNzExIDExLjcwNzFMMTIuNzA3MSA1LjcwNzExQzEzLjA5NzYgNS4zMTY1OCAxMy4wOTc2IDQuNjgzNDIgMTIuNzA3MSA0LjI5Mjg5QzEyLjMxNjYgMy45MDIzNyAxMS42ODM0IDMuOTAyMzcgMTEuMjkyOSA0LjI5Mjg5TDYgOS41ODU3OUw0LjcwNzExIDguMjkyODlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgCheckSquare16 as ReactComponent };